import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { SkyLightStateless } from 'react-skylight';
import { Translate } from 'react-redux-i18n';
import { Field } from 'redux-form';
import ReactDOM from 'react-dom';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import NotificationSystem from 'react-notification-system';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import NewFavoriteModal from '../../containers/Favorites/favoriteModal';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { InputField } from '../../components/Common/inputField';
import SalesInventoryInfo from '../../containers/Sales/salesInventoryInfo';
import TypeRadios from '../../containers/Common/TypeRadios';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import checkPermission from '../Common/permissions';

import { ROOT_URL, companyCodeTitle, isLAP, isOLG } from '../../actions/root_url';
import axios from 'axios';
import {UPLOAD_FAVORITE_URL} from '../../actions/url'
class FavoriteList extends Component {
    static contextTypes = {
      router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,

        createFavoriteOpen: false,
        showInventoryOpen: false,
        currentCustomerID: null,
        currentCustomerName: null,
        SalesFavoriteList_id: null,

        customers: {
          rows: [],
          filters: {},
          selectedRows: null,
          sortColumn: null,
          sortDirection: null,
        },

        favorites: {
          rows: [],
          filters: {},
          selectedRows: null,
          selectedIndexes: [],
          sortColumn: null,
          sortDirection: null,
        },

        suggestValue: '',
        productSearchType: 'ProductNum',

      };

      this.handleResize = this.handleResize.bind(this);
      this.openFavoriteCreate = this.openFavoriteCreate.bind(this);
      this.closeFavoriteCreate = this.closeFavoriteCreate.bind(this);
      this.addFavorite = this.addFavorite.bind(this);
      this.saveFavoriteList = this.saveFavoriteList.bind(this);
      this.selectInventoryInfo = this.selectInventoryInfo.bind(this);
      this.closeShowInventory = this.closeShowInventory.bind(this);
      this.handleOnFocus = this.handleOnFocus.bind(this);
      this.setAllProductQuantity = this.setAllProductQuantity.bind(this);
      this.handleAfterShowInventoryClose = this.handleAfterShowInventoryClose.bind(this);
      this.searchInventory = this.searchInventory.bind(this);
    }

    componentDidMount() {
      document.title = companyCodeTitle;
      // window.addEventListener('resize', this.handleResize);
      this.props.setValue('favoriteList', 'SearchType', 'RefNum');
      // this.props.fetchCustomerFavorites();
      this._notificationSystem = this.refs.notificationSystem;
      this.props.fetchCustomersWithFavorites();
      // this.props.fetchInventories();
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.customers && nextProps.customers !== this.props.customers) {
        const customers = { ...this.state.customers, rows: nextProps.customers };
        this.setState({ customers });
      }

      if (nextProps.customerFavoritesList && nextProps.customerFavoritesList
        !== this.props.customerFavoritesList) {
        const favorites = { ...this.state.favorites, rows: nextProps.customerFavoritesList };
        this.setState({ favorites });
      }

      if (nextProps.favoriteList && nextProps.favoriteList !== this.props.favoriteList) {
        if (nextProps.favoriteList.Sales_FavoriteList_Lines) {
          const rows = [...nextProps.favoriteList.Sales_FavoriteList_Lines];
          const favorites = { ...this.state.favorites, rows };
          this.setState({ favorites });
        }
      }

      if (nextProps.saveFavoriteListSuccess && nextProps.saveFavoriteListSuccess !== this.props.saveFavoriteListSuccess) {
        this.handleAddNotification('save_successful', 'success');
      }

      if (nextProps.saveFavoriteListError && nextProps.saveFavoriteListError !== this.props.saveFavoriteListError) {
        this.handleAddNotification('save_failed', 'error');
      }
    }

    setAllProductQuantity() {
      // this.props.setValue('favoriteList', 'Quantity', quantity);
    }

    _notificationSystem = null;

    closeFavoriteCreate() {
        this.setState({ createFavoriteOpen: false });
    }

    openFavoriteCreate() {
       this.setState({ createFavoriteOpen: true });
    }

    selectInventoryInfo(productNum, selectedInventoryRow) {
      let rows = [];
      if (this.state.favorites.rows) {
        rows = [...this.state.favorites.rows];
      }
      rows = rows.filter((obj) => {
        const match = String(obj.ProductNum) !== selectedInventoryRow.ProductNum;
        return match;
      });
      const newRow = { ...selectedInventoryRow };
      newRow.Ordered = newRow.Purchased;
      rows.unshift({ ...newRow });
      const favorites = { ...this.state.favorites, rows };
      this.setState({
        selectedInventoryRow,
        favorites,
        suggestValue: '',
      });
    }

    handleAddNotification(title, level) {
      this._notificationSystem.addNotification({
        title: <Translate value={title} />,
        level,
      });
    }

    handleOptionChange = (changeEvent) => {
      this.setState({ productSearchType: changeEvent.target.value });
    }

    handleOnFocus(event) {
      event.target.select();
    }

    addFavorite(newFavorite) {
        // let index =  _.findIndex(this.state.favorites.rows, { 'Product_id': newFavorite.id });
        // if (index == -1)
        //   return;
        const newRow = {
          Product_id: newFavorite.Product_id,
          ProductName: newFavorite.Name,
          Description: newFavorite.Description,
          RefNum: newFavorite.ProductNum,
          ProductNum: newFavorite.ProductNum,
          PreSale: newFavorite.PreSale,
          InStock: newFavorite.InStock,
          Ordered: newFavorite.Purchased,
          RefPurchasingPrice: newFavorite.refPrice,
        };

        const preRows = this.state.favorites.rows;
        preRows.push(newRow);
        const favorites = { ...this.state.favorites, rows: preRows };
        this.setState({ favorites });
    }

    removeRow(ProductNum) {
      let rows = [...this.state.favorites.rows];

      rows = rows.filter((obj) => {
        const match = String(obj.ProductNum) !== ProductNum;
        return match;
      });
      const favorites = { ...this.state.favorites, rows };
      this.setState({ favorites });
    }

    saveFavoriteList() {
      // this.props.addNewCustomerFavorite(this.state.favorites.rows, this.state.currentCustomerID);
      const id = this.state.currentCustomerID;
      const rows = [...this.state.favorites.rows];
      this.props.saveFavoriteList({ Customer_id: id, Sales_FavoriteList_Lines: rows });
    }

    handleResize() {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton });
    }

    openShowInventory(event) {
      if (!this.props.ProductInformation || this.props.ProductInformation === '') {
        return;
      }
      switch (event.charCode) {
          case 13: // ENTER
            event.preventDefault();
            if (this.state.currentCustomerID) {
              this.setState({ showInventoryOpen: true });
              break;
            } else {
              this.setState({ case: 'noCustomerChosen', confirmOpen: true });
            }
            break;
          default:
            return;
      }
    }

    searchInventory() {
      if (!this.props.ProductInformation || this.props.ProductInformation === '') {
        return;
      }

      if (this.state.currentCustomerID) {
        this.setState({ showInventoryOpen: true });
      } else {
        this.setState({ case: 'noCustomerChosen', confirmOpen: true });
      }
    }

    closeShowInventory() {
      this.handleAfterShowInventoryClose('ProductSearch');
      this.setState({ showInventoryOpen: false });
    }

    handleAfterShowInventoryClose(value) {
      ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    }

    checkPermission(permission) {
        return this.props.userPermissions.indexOf(permission) === -1;
    }

    uploadChange(event) {

    }

    upload(id) {
      const input=document.createElement("input");
      input.setAttribute("type","file");
      input.setAttribute("name","fujian");
      input.click();
      input.onchange = (event) => {
        const file = event.target.files[0] || event.dataTransfer.files[0];
        const data = new FormData();
        data.append('favouritesfile', file)
        axios.post(
          `${UPLOAD_FAVORITE_URL}${id}`, data,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          },
        )
          .then((response) => {
            this.props.fetchFavoriteList(id);
            input.remove();
          }, (err) => {
            alert(err.data)
            input.remove();
          });
        
      };
    }

    renderCustomerList() {
      if (this.props.customersIsLoading && !this.props.customersError) return <Spinner />;
      else if (this.props.customersError) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">
              {JSON.stringify(this.props.customersError)}
            </div>
          </ContentWrapper>
        );
      }
          // Parameters of the react-data-grid
          const getRows = () => {
            const Rows = Data.Selectors.getRows(this.state.customers);
            return Rows;
          };

          const getSize = () => {
            const RowLength = getRows().length;
            return RowLength;
          };

          const rowGetter = rowIdx => {
            const rows = getRows();
            return rows[rowIdx];
          };

          const handleGridSort = (sortColumn, sortDirection) => {
            const customers = { ...this.state.customers, sortColumn, sortDirection };
            this.setState({ customers });
          };

          const onRowClick = (rowIdx, row) => {
            const favorites = { ...this.state.favorites, rows: row.Sales_FavoriteList_Lines };
            this.props.fetchFavoriteList(row.Customer_id);
            this.setState({
              SalesFavoriteList_id: row.SalesFavoriteList_id,
              currentCustomerID: row.Customer_id,
              currentCustomerName: row.Name,
              favorites });
          };

          const handleFilterChange = filter => {
              const newFilters = Object.assign({}, this.state.customers.filters);
              if (filter.filterTerm) {
                  newFilters[filter.column.key] = filter;
              } else {
                  delete newFilters[filter.column.key];
              }
              const customers = { ...this.state.customers, filters: newFilters };
              this.setState({ customers });
          };
          // Column difinition

          const columns = [
              {
                  key: 'CustomerNum',
                  name: <Translate value="cust_no" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  width: 90,
              },
              {
                  key: 'Name',
                  name: <Translate value="cust_name" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
          ];

          return (
              <Row>
                <Col sm={12} id="FavoriteList-dataGrid1">
                  <div>
                    <ReactDataGrid
                        rowKey='Customer_id'
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        toolbar={<Toolbar enableFilter />}
                        onAddFilter={handleFilterChange}
                        rowsCount={getSize()}
                        minHeight={640}
                        onRowClick={onRowClick}
                    />
                  </div>
                </Col>
              </Row>
          );
    }

    renderFavoriteProductList() {
      const that = this;
      if (this.props.isLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
          </ContentWrapper>
        );
      }
      // Parameters of the react-data-grid
      const getRows = () => {
        const Rows = Data.Selectors.getRows(this.state.favorites);
        return Rows;
      };

      const getSize = () => {
        const RowLength = getRows().length;
        return RowLength;
      };

      const rowGetter = rowIdx => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const handleGridSort = (sortColumn, sortDirection) => {
          const favorites = { ...this.state.favorites, sortColumn, sortDirection };
          this.setState({ favorites });
      };

      const handleFilterChange = filter => {
          var filteredRows = [...this.state.favorites.rows];
          let newFilters = Object.assign({}, this.state.favorites.filters);
          if (filter.filterTerm) {
              newFilters[filter.column.key] = filter;
          } else {
              delete newFilters[filter.column.key];
          }
          for (var property in newFilters) {
            if (newFilters.hasOwnProperty(property)) {
              filteredRows = filteredRows.filter(function(obj) {
                if (obj[property]) {
                  return String(((String(obj[property])).toUpperCase()).includes((newFilters[property].filterTerm).toUpperCase()));
                } else {
                  return false;
                }
              });
            }
          }

          const favorites = { ...this.state.favorites, filters: newFilters, filteredRows };
          this.setState({ favorites });
      }
      const onClearFilters = () => {
        //all filters removed
        this.setState({ filters: {} });
      }

      const IsVariableFormatter = React.createClass({
          render() {
            return (
              <span>
                <Button
                  bsStyle="danger"
                  className="textAlignStyle"
                  style={{ height: '23px', width: '39px', padding: '0px' }}
                  onClick={() => {
                    const ProductNum = this.props.dependentValues.ProductNum;
                    that.removeRow(ProductNum);
                  }}
                >X</Button>
              </span>
            );
          }
      });
      // Column difinition

      const columns = [
        {
            name: <Translate value="del" />,
            width: 50,
            formatter: IsVariableFormatter,
            getRowMetaData: (row) => row
        },
        ...isOLG ? [
          {
            key: 'RefNum',
            name: <Translate value="item_no" />,
            resizable: true,
            sortable: true,
            width: 85,
            filterable: true
          }
        ] : [
          {
            key: 'ProductNum',
            name: <Translate value="product_num" />,
            resizable: true,
            sortable: true,
            width: 85,
            filterable: true
          }
        ],
        {
            key: 'Name',
            name: <Translate value="product_name" />,
            resizable: true,
            sortable: true,
            filterable: true
        },
        {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 200,
        },
        {
            key: 'Purchased',
            name: <Translate value="purchased" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true
        },
        {
            key: 'InStock',
            name: <Translate value="instock" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true
        },
        {
            key: 'PreSale',
            name: <Translate value="presale" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true
        },
      ];

      return (
          <Row>
            <Col sm={12}>
              <div id="FavoriteList-dataGrid2">
                <ReactDataGrid
                    rowKey='Product_id'
                    onGridSort={handleGridSort}
                    toolbar={<Toolbar enableFilter />}
                    columns={columns}
                    headerRowHeight={45}
                    onClearFilters={onClearFilters}
                    onAddFilter={handleFilterChange}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    minHeight={557}
                />
              </div>
          </Col>
        </Row>
      );
    }

    renderAutoSuggest() {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.selectInventoryInfo}
          />
        </div>
      );
    }

    renderEp() {
      if(isLAP) {

      } else {
        
      }
    }

    renderCurrentCustomer() {
      if (this.state.currentCustomerID == null) {
        return (
          <h2 style={{ margin: '5px' }} id="choose-customer"> - <Translate value="choose_a_customer" /></h2>
        );
      }
      return (
        <h2 style={{ margin: '5px' }}> - {this.state.currentCustomerName}</h2>
      );
    }

    render() {
      const style = {
        NotificationItem: { // Override the notification item
          DefaultStyle: { // Applied to every notification, regardless of the notification level
            margin: '10px 5px 2px 1px'
          },

          success: { // Applied only to the success notification item
            color: 'red'
          }
        }
      };
      const selectInventoryInformation = (<Translate value="select_inventory_information" />);
      const createDialogInventoryStyle = {
        height: '700px',
        width: '1000px',
        marginLeft: '-28%',
        marginTop: '-20%',
      };
      const createDialogStyle = {
          width: '600px',
          marginLeft: '-10%',
      };

      let exportUrl = ROOT_URL + "v1/sale/favorite/export/" + this.state.currentCustomerID
                      + "?Bearer=" + localStorage.getItem('token');

      let exportTemUrl = ROOT_URL + "v1/sale/favorite/export/?Bearer=" + localStorage.getItem('token');

      return (
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="sales_management" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              <Translate value="favorites_list" />
            </Breadcrumb.Item>
          </Breadcrumb>
          <Grid id="sales-favorite-list">
            <Row>
              <Col sm={3}>
                <h1><Translate value="customers" /></h1>
                <Panel className="table-collapse-fix">
                  {this.renderCustomerList()}
                </Panel>
              </Col>
              <Col sm={9}>
                <h1 style={{ float: 'left' }}><Translate value="favorite_list" /></h1> {this.renderCurrentCustomer()}
                <Row>
                  <Col xs={12}>
                    <Panel id="favorite-list-panel">
                      <Row style={{ marginTop: 6 }}>
                        <Col xs={12}>
                          <TypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          {this.renderAutoSuggest()}
                        </Col>
                      </Row>
                    </Panel>
                  </Col>
                </Row>
                <Panel id="favorite-list" className="position-relative table-collapse-fix">
                  <ButtonToolbar className="table-buttons">
                    {isLAP && <Button
                      bsStyle="primary"
                      className="pull-right"
                      onClick={()=>{
                        this.upload(this.state.currentCustomerID);
                      }}
                      disabled={this.state.currentCustomerID == null || !checkPermission('change_sales_favorites')}
                    >
                     <Translate value="upload" />
                    </Button>}
                    <Button
                      bsStyle="success"
                      className="pull-right"
                      disabled={this.state.currentCustomerID == null || !checkPermission('change_sales_favorites')}
                      onClick={this.saveFavoriteList}
                    >
                      <em className="fa fa-save marginRightStyle" />
                      <Translate value="save" />
                    </Button>
                    {isLAP && <Button
                      bsStyle="primary"
                      className="pull-right"
                      href={exportTemUrl}
                      disabled={!checkPermission('print_sales_favorites')}
                    >
                      <em className="fa fa-print marginRightStyle" />
                      <Translate value="export_template" />
                    </Button>}
                    <Button
                      bsStyle="primary"
                      className="pull-right"
                      href={exportUrl}
                      disabled={this.state.currentCustomerID == null || !checkPermission('print_sales_favorites')}
                    >
                      <em className="fa fa-print marginRightStyle" />
                      <Translate value="export_to_excel" />
                    </Button>
                  </ButtonToolbar>
                  {this.renderFavoriteProductList()}
                </Panel>
              </Col>
            </Row>
            <NotificationSystem ref="notificationSystem" style={style} />
            <SkyLightStateless
              dialogStyles={createDialogStyle}
              isVisible={this.state.createFavoriteOpen}
              onCloseClicked={() => {
                this.closeFavoriteCreate();
              }}
              title="Create a new Favorite"
            >
              <NewFavoriteModal
                closeC={this.closeFavoriteCreate}
                closeA={this.addFavorite}
                currentList={this.state.favorites}
                SalesFavoriteList_id={this.state.SalesFavoriteList_id}
              />
            </SkyLightStateless>
            <SkyLightStateless
              dialogStyles={createDialogInventoryStyle}
              isVisible={this.state.showInventoryOpen}
              onCloseClicked={() => {
                this.closeShowInventory('ProductSearch');
              }}
              title={selectInventoryInformation}
            >
              <SalesInventoryInfo
                Customer_id={this.state.currentCustomerID}
                SearchType={this.props.SearchType}
                SearchValue={this.props.ProductInformation}
                closeShowInventory={this.closeShowInventory}
                selectInventoryInfo={this.selectInventoryInfo}
                setSaleRowValue={this.props.setSaleRowValue}
                setAllProductQuantity={this.setAllProductQuantity}
                formName={'favoriteList'}
              />
            </SkyLightStateless>
          </Grid>
        </ContentWrapper>
      );
    }
}

export default FavoriteList;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/favoriteList.jsx